module.exports = __webpack_public_path__ + "static/assets/ccf5cd43b7f5661f8141f879e4a015bb.png";